import * as React from "react";
import { connect } from "react-redux";
// room-preferences-checkbox imports
import { ICheckboxContainer, ICheckboxProps, ICheckboxState } from "./RoomPreferencesSettings.d";
import * as s from "./RoomPreferencesSettings.styles";
// other internals
import { A } from "@ui";
import { InfoTip } from "@components/tool-tip";
// state
import { IReduxState } from "@reducers/root.reducer";
// material-ui
import { Checkbox } from "@material-ui/core";

//////////////////
// COMPONENT
//////////////////
class RoomPreferencesCheckboxCmpt extends React.Component<ICheckboxProps, ICheckboxState> {
  constructor(props: ICheckboxProps) {
    super(props);

    this.state = {
      checked: props.room.isPreferred,
    };
  }

  // ~-~-~-~-~-~-~-
  // Helpers
  // ~-~-~-~-~-~-~-
  private onCheck = () => {
    this.props.onCheck(this.props.room.roomId, !this.state.checked);
    this.setState({ checked: !this.state.checked });
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  private renderTipContent() {
    return <span style={s.room.tipContent}>You meet in this room on a regular basis</span>;
  }

  public render() {
    const { isSuggested, name } = this.props.room;
    const tipTarget = <A style={s.room.suggested}>Suggested</A>;

    return (
      <div style={s.room.container}>
        <div style={s.room.name}>{name}</div>
        <div style={s.room.checkbox}>
          {isSuggested ? (
            <InfoTip text={this.renderTipContent()} targetElement={tipTarget} tipType={"info"} />
          ) : (
            ""
          )}
          <Checkbox color="primary" checked={this.state.checked} onChange={this.onCheck} />
        </div>
      </div>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: ICheckboxContainer) {
  return {}; // add redux state here, if needed
}

export const RoomPreferencesCheckbox = connect(mapStateToProps, {})(RoomPreferencesCheckboxCmpt);
